module.exports = __webpack_public_path__ + "img/公司官网_域贝大数据平台.6199adf9.png";